// frontend/src/pages/HomePage.jsx
// Main homepage component

import React, { useEffect, useState } from 'react';
import Home from '../components/Home';
import Partners from '../components/Partners';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import { cmsAPI } from '../utils/api';

const HomePage = () => {
  const [cms, setCms] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    cmsAPI.homepage({ signal: controller.signal })
      .then(({ data }) => setCms(data.data))
      .catch((error) => {
        if (error.code !== 'ERR_CANCELED') {
          setCms(null);
        }
      });

    return () => controller.abort();
  }, []);

  return (
    <div>
      <Home
        hero={cms?.sections?.find((section) => section.type === 'hero')?.content}
        featuredCoursesSection={cms?.sections?.find((section) => section.type === 'featured_courses')?.content}
        courseCategoriesSection={cms?.sections?.find((section) => section.type === 'course_categories')?.content}
      />
      <Partners />
      <Features section={cms?.sections?.find((section) => ['feature_grid', 'features'].includes(section.type))?.content} />
      <Testimonials items={cms?.testimonials} />
      <FAQ items={cms?.faqs} />
    </div>
  );
};

export default HomePage;
